var FittHTTPCoreUtils = require('./utils.js'),
createError = FittHTTPCoreUtils.createError;

/**
                                              * Resolve or reject a Promise based on response status.
                                              *
                                              * @param {Function} resolve - A function that resolves the promise.
                                              * @param {Function} reject - A function that rejects the promise.
                                              * @param {Object} response - The response.
                                              */
function settle(resolve, reject, response) {

  var respConfig = response && response.config,
  validateResponse = respConfig && respConfig.validateResponse,
  respStatus = response && response.status,
  respURL = response && response.url,
  respData = response && response.data,
  options = respConfig && respConfig.options,
  allowError = options && options.allowError,
  err;

  if (allowError || !respStatus || typeof validateResponse != 'function' || validateResponse(response)) {
    resolve(response);
    return;
  }

  err = createError('HTTP request failed with status code ' + respStatus + ': ' + respURL,
  respURL,
  respConfig,
  null,
  respStatus,
  respData);


  reject(err);
}

if (typeof module !== 'undefined') {
  module.exports = settle;
}


//////////////////
// WEBPACK FOOTER
// ../~/espn-fitt/es5/fitt-http/core/settle.js
// module id = 784
// module chunks = 0